export { default as PromotionBadge } from './promotion-badge'
